export const fromConfig = {
    dialogAttr: {
        title: '新增',
        width: '50%'
    },
    dialogFooter: true,
    fromComponent: {
        labelWidth: '100px',
        component: [
            {
                component: 'el-select',
                prop: 'domainName',
                name: '领域',
                width: '80%',
                relevance: 'sourceSys',
                useAttr: {
                    placeholder: '选择领域',
                    maxlength: 16,
                    filterable: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            },
             {
                component: 'el-select',
                prop: 'sourceSys',
                name: '来源系统',
                width: '80%',
                useAttr: {
                    placeholder: '请选择来源系统',
                    maxlength: 16,
                    filterable: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            },
            {
                component: 'el-input',
                prop: 'billType',
                name: '单据类型',
                width: '80%',
                useAttr: {
                    placeholder: '请选择单据类型',
                    maxlength: 16,
                    clearable: true
                }
            },
            {
                component: 'el-input',
                prop: 'billTypeName',
                name: '单据类型名称',
                width: '80%',
                useAttr: {
                    placeholder: '请输入单据类型名称',
                    maxlength: 32,
                    clearable: true
                }
            },
            {
                component: 'el-switch',
                prop: 'enableFlag',
                name: '启用/禁用',
                useAttr: {
                    'active-value': 'Y',
                    'inactive-value': 'N'
                }
            },
            {
                component: 'el-input',
                type: 'textarea',
                prop: 'remark',
                name: '备注',
                width: '80%',
                useAttr: {
                    placeholder: '请输入备注',
                    row: '5',
                    resize: 'none',
                    maxlength: 256,
                    clearable: true
                }
            }

        ],
        rules: {
            domainName: [
                { required: true, message: '请选择领域', trigger: 'change' }
            ],
            sourceSys: [
                { required: true, message: '请选择来源系统', trigger: 'change' }
            ]
        }
    }

};
